document.addEventListener("DOMContentLoaded", () => {
  const headerForm = document.querySelector(".header .header__form");
  const headerInput = headerForm?.querySelector(".header__input-search");
  const headerSearch = headerForm?.querySelector(".header__search");
  const header = document.querySelector(".header");

  if (headerForm && headerInput && headerSearch) {
    headerSearch.addEventListener("click", (e) => {
      if (!headerForm.classList.contains("header__form--open")) {
        e.preventDefault();
      }
      if (headerForm.classList.contains("header__form--open") && !headerInput.value.trim().length) {
        headerForm.classList.remove("header__form--open");
        e.preventDefault();
        return;
      }
      headerInput.focus();
      headerForm.classList.add("header__form--open");
    });

    document.addEventListener("click", (e) => {
      if (e.target !== headerSearch && !headerSearch.contains(e.target)) {
        if (headerForm.classList.contains("header__form--open") && !headerInput.value.trim().length) {
          headerForm.classList.remove("header__form--open");
        }
      }
    });
  }

  const menuForm = document.querySelector(".main-menu");
  const menuInput = menuForm.querySelector(".header__input-search");
  const menuSearch = menuForm?.querySelector(".header__search");
  if (menuForm && menuSearch) {
    menuSearch.addEventListener("click", (e) => {
      if (!menuInput.value.trim().length) {
        e.preventDefault();
      }
    });
  }

  const subLists = document.querySelectorAll(".header__sub-list");
  if (subLists) {
    const resize = () => {
      subLists.forEach((subList) => {
        const wrapper = subList.querySelector(".header__wrapper");
        const headerItem = subList.closest(".header__item");
        let rightDistance = 20;
        // if (wrapper.getBoundingClientRect().left + wrapper.clientWidth > window.innerWidth - rightDistance) {
        //   // subList.classList.add("header__sub-list--right");
        // } else if (wrapper.getBoundingClientRect().right + wrapper.clientWidth + rightDistance < window.innerWidth) {
        //   // subList.classList.remove("header__sub-list--right");
        // }

        let headerItemRect = headerItem.getBoundingClientRect();
        let wrapperOverflow = headerItemRect.left + wrapper.clientWidth - window.innerWidth + Number.parseInt(window.getComputedStyle(subList).left) + rightDistance;
        if (wrapperOverflow > 0) {
          subList.style.transform = `translateX(-${wrapperOverflow}px)`;
        } else {
          subList.style.removeProperty("transform");
        }
        subList.style.setProperty("--max-height", `${wrapper.clientHeight}px`);
      });
    };
    window.addEventListener("resize", resize);
    setTimeout(() => {
      resize();
    });
  }

  const burgerMenu = document.querySelector(".header__menu-burger");
  const mainMenu = document.querySelector(".main-menu");
  if (burgerMenu && mainMenu) {
    burgerMenu.addEventListener("click", () => {
      if (burgerMenu.classList.contains("header__menu-burger--open")) {
        mainMenu.classList.remove("main-menu--open");
        burgerMenu.classList.remove("header__menu-burger--open");
        burgerMenu.classList.add("header__menu-burger--revert-animate");
        document.body.style.overflow = "unset";
        header.classList.remove("header--collapsed");
        setTimeout(() => {
          burgerMenu.classList.remove("header__menu-burger--revert-animate");
        }, 301);
        return;
      }
      document.body.style.overflow = "hidden";
      document.body.style.setProperty("overflow", "hidden", "important");
      burgerMenu.classList.add("header__menu-burger--open");
      mainMenu.classList.add("main-menu--open");
      header.classList.add("header--collapsed");
    });
  }

  const tabButtons = document.querySelectorAll(".main-menu__button");
  const tabContents = document.querySelectorAll(".main-menu__tab");

  if (tabContents && tabButtons && tabContents.length === tabButtons.length) {
    let activeIndex = null;

    const viewTab = (index) => {
      if (activeIndex !== null) {
        tabButtons[activeIndex].classList.remove("main-menu__button--active");
        tabContents[activeIndex].classList.remove("main-menu__tab--view");
      }
      activeIndex = index;
      tabButtons[activeIndex].classList.add("main-menu__button--active");
      tabContents[activeIndex].classList.add("main-menu__tab--view");
    };

    tabButtons.forEach((button, index) => {
      if (button.classList.contains("main-menu__button--active")) {
        activeIndex = index;
        viewTab(index);
      }
      button.addEventListener("click", () => {
        viewTab(index);
      });
    });
    if (activeIndex === null) {
      viewTab(0);
    }
  }
});
